import { Component } from 'react';
import { logout } from '../../utility/account.js';
import { withRouter } from 'react-router-dom';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';
import { addMessage } from '../../actions/messages.js';

/**
 * Logout screen, only redirects based on logout call result.
 *
 * @extends React.Component
 */
class Logout extends Component {
  /**
   * Perform log out in API.
   */
  logout = () => {
    if (!this.props.token) {
        this.props.history.push('/login');
        return;
    }
    var ctx = this;
    logout(this.props.token, this.props.dispatch, function(loggedIn) {
      if (!loggedIn) {
        ctx.props.dispatch(addMessage('Du er nu logget ud.', 'success'));
        ctx.props.history.push('/login');
      }
      else {
        ctx.props.dispatch(addMessage('Log ud fejlede, prøv venligst igen senere.', 'danger'));
        ctx.props.history.push('/conversations');
      }
    });
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.logout();
  }

  /** @inheritdoc */
  render() {
    return null;
  }
}

export default withRouter(withUser(connect()(Logout)));



// WEBPACK FOOTER //
// ./src/screens/Logout/index.js